import { Flex } from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type ScheduledMessageParticipantTimeProps = {
  children: React.ReactNode;
};

export const ScheduledMessageParticipantTime = ({
  children,
}: ScheduledMessageParticipantTimeProps) => (
  <Flex alignItems="center" gap=".5rem" justifyContent="right">
    <Typography
      type="small"
      textAlign="right"
      color="whiteTotal"
      dataTestid="scheduled-for-time"
    >
      {children}
    </Typography>
    <Icon name={iconNames.tick} fill="white" />
  </Flex>
);
